import { Box, Typography, Button } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

const EmptyState = ({ icon, title, subtitle, actionLabel, onAction }) => (
  <Box textAlign="center" py={8} px={4}>
    <Box sx={{ color: 'rgba(13,29,62,0.12)', mb: 2, lineHeight: 1 }}>
      {icon || <InboxIcon sx={{ fontSize: 64 }} />}
    </Box>
    <Typography fontWeight={600} color="text.secondary" fontSize={15} mb={0.5}>{title}</Typography>
    {subtitle && (
      <Typography variant="body2" color="text.secondary" mb={actionLabel ? 2.5 : 0}>{subtitle}</Typography>
    )}
    {actionLabel && onAction && (
      <Button variant="contained" onClick={onAction}
        sx={{ backgroundColor: '#0d1d3e', borderRadius: 2, '&:hover': { backgroundColor: '#162d5a' } }}>
        {actionLabel}
      </Button>
    )}
  </Box>
);

export default EmptyState;
